<template>
  <v-container class="text-center" fill-height style="height: calc(100vh - 58px)">
    <v-row align="center">
      <v-col>
        <h1 class="display-2 primary--text">{{ $t('error.404') }}</h1>
        <p>{{ $t('error.pageNotExist') }}</p>
        <v-btn :to="'/'" color="primary" outlined>{{ $t('error.getMeOutOfHere') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    lang: {
      type: String,
      default: 'en'
    }
  },
  created() {
    this.$ssrContext && this.$ssrContext.res.status(404)
  }
}
</script>
